/* eslint-disable indent */
import styled from 'styled-components';
import {
  ModalContent,
  InputWithAction,
  InputField,
  Space,
  Text,
} from '@cashfree-intl/coherent';
export const StyledODSForm = styled(ModalContent)`
  .modal-content {
    padding: 1.5rem 2.25rem;
  }
`;
export const StyledInputWithAction = styled(InputWithAction)`
  margin-bottom: 0 !important;
  .ui.label {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .ui.input {
    margin-bottom: 0 !important;
  }
  input[type='number'] {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
`;
export const StyledVendorIdInput = styled.div`
  .ui.input {
    margin-bottom: 0 !important;
  }
`;
export const StyledTagsInput = styled(InputField)`
  .ui.input {
    width: 14rem;
  }
`;
export const StyledMerchantTransferSpace = styled(Space)`
  background-color: ${({ transferFrom }) =>
    transferFrom === 'MERCHANT'
      ? 'var(--SELECTED)'
      : 'var(--BACKGROUND_LIGHT)'};
  border: ${({ transferFrom }) =>
    transferFrom === 'MERCHANT' ? '1px solid var(--PRIMARY)' : ''};
  padding: 16px 0 16px 16px;
  border-radius: 0.5rem;
  width: 14rem;
`;
export const StyledChargesSpace = styled(Space)`
  width: 416px;
  background: #f9f5ff;
  border-radius: 4px;
`;
export const StyledVendorTransferSpace = styled(Space)`
  background-color: ${({ transferFrom }) =>
    transferFrom === 'VENDOR' ? 'var(--SELECTED)' : 'var(--BACKGROUND_LIGHT)'};
  border: ${({ transferFrom }) =>
    transferFrom === 'VENDOR' ? '1px solid var(--PRIMARY)' : ''};
  padding: 16px 0 16px 16px;
  border-radius: 0.5rem;
  width: 14rem;
`;
export const StyledOptionalTag = styled(Text)`
  padding: 2px 8px;
  background-color: var(--TABLE_COLUMN);
  border-radius: 2px;
`;
export const StyledAddTags = styled(Text)`
  cursor: pointer;
`;
